import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const TooltipWrapper = styled.div`
  position: relative;
  display: inline-block;
  z-index: 100;
`

const TooltipText = styled.span`
  visibility: hidden;
  background-color: var(--color-neutral-120);
  text-align: ${props => props.align};
  border-radius: 6px;
  padding: var(--spacing-2);
  width: ${props => props.width}px;
  position: absolute;
  z-index: 1;
  top: 50%;
  left: calc(100% + var(--spacing-0-5)); /* Adjust the left position to prevent overlap */
  transform: translateY(calc(-50% - var(--spacing-0-5)));
  opacity: 0;
  transition: opacity 0.3s;
  white-space: normal;
  box-sizing: content-box;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    right: 100%;
    margin-top: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent var(--color-neutral-120) transparent transparent; /* Fix the tail direction */
  }

  ${TooltipWrapper}:hover & {
    visibility: visible;
    opacity: 1;
  }
`

const Tooltip = ({ text, children, width = 158, align = 'center' }) => {
  return (
    <TooltipWrapper>
      {children}
      <TooltipText width={width}>
        {typeof text === 'string' ? (
          <span className="typo-body-small text-neutral-70">{text}</span>
        ) : (
          text
        )}
      </TooltipText>
    </TooltipWrapper>
  )
}

Tooltip.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  children: PropTypes.node.isRequired,
  width: PropTypes.number,
  align: PropTypes.oneOf(['left', 'center', 'right']),
}

export { Tooltip }
